import PropTypes from 'prop-types'
import { createUseStyles } from '../../../helpers/createStyles'
import { theme } from '../../../styles/theme'
import ArrowLeft from './icons/arrow-left.svg'
import ArrowRight from './icons/arrow-right.svg'

const ColorExplorerNavigation = ({
  onPressNext,
  onPressPrev,
  nextDisabled,
  prevDisabled
}) => {
  const styles = useStyles()
  return (
    <div className={styles.root}>
      <button onClick={onPressPrev} disabled={prevDisabled}>
        <ArrowLeft />
      </button>
      <button onClick={onPressNext} disabled={nextDisabled}>
        <ArrowRight />
      </button>
    </div>
  )
}

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    gap: theme.spacingPx(1),
    '& button': {
      padding: theme.spacing(1),
      '&:disabled': {
        opacity: 0.4
      },
      '&:last-child': {
        marginRight: theme.spacing(-1)
      }
    }
  }
})

export const colorExplorerNavigationPropTypes = {
  onPressNext: PropTypes.func.isRequired,
  onPressPrev: PropTypes.func.isRequired,
  nextDisabled: PropTypes.bool.isRequired,
  prevDisabled: PropTypes.bool.isRequired
}

ColorExplorerNavigation.propTypes = colorExplorerNavigationPropTypes

export default ColorExplorerNavigation
